<template>
  <p
    ref="text"
    class="text-with-line-highlight"
  >
    <text-line
      ref="lines"
      :key="index"
      v-for="(line, index) in linesNumber"
      :style="{ height: lineLineHeight, top: index*parseInt(lineLineHeight, 10) + 'px' }"
    />
    <span
      class="text-line"
      ref="textLine"
    />
    <span v-html="textHtml" />
  </p>
</template>

<script>
import inViewport from 'vue-in-viewport-mixin'
import TextLine from '@/components/TextHighlightAnimation/TextHighlightLine'
import createTextAnimation from '@/assets/js/highlight/text'
import createTextWithLineAnimation from '@/assets/js/highlight/textWithLine'

export default {
  components: {
    TextLine
  },
  mixins: [inViewport],
  props: {
    listAnimationStart: {
      type: Boolean,
      default: false
    },
    textHtml: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      linesNumber: 0,
      lineLineHeight: '1em',
      textTimeline: new TimelineMax({ paused: true }),
      lines: false,
      text: false
    }
  },
  watch: {
    listAnimationStart (start) {
      if (start) {
        this.textTimeline.play()
      } else {
        this.textTimeline.pause()
        this.textTimeline.seek(0)
      }
    }
  },
  mounted () {
    this.text = this.$refs.text
    window.addEventListener('resize', this.calculateLines)
    this.calculateLines()
  },
  destroyed () {
    window.removeEventListener('resize', this.calculateLines)
  },
  methods: {
    calculateLines (event) {
      const lineHeight = this.text.clientHeight
      this.lineLineHeight = window.getComputedStyle(this.text, null).getPropertyValue('line-height')
      this.linesNumber = Math.ceil(lineHeight / parseFloat(this.lineLineHeight)) + 2
      setTimeout(() => {
        this.addLinesToTimeline()
      }, 0)
    },
    addLinesToTimeline () {
      const textWithLine = this.$refs.textLine
      TweenLite.set(textWithLine, { height: 0 })
      const textWithLineAnimation = createTextWithLineAnimation(textWithLine)
      this.lines = this.$refs.lines.map(line => line.$el)
      if (this.lines) {
        const textAnimation = createTextAnimation(this.lines, this.delay)

        this.textTimeline
          .clear()
          .add(textWithLineAnimation)
          .add(textAnimation)
          .addCallback(() => {
            this.$emit('next')
          }, '-=0.6')
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .text-with-line-highlight {
    position: relative;
    overflow: hidden;
  }
  .text-line {
    position: absolute;
    width: 4px;
    height: .8em;
    background-color: #fff;
    left: 0;
    top: 0.3em;
  }
</style>



// WEBPACK FOOTER //
// src/components/TextHighlightAnimation/TextWithLineHighlight.vue